// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"VideoPicker_videoContainer__1JDmp"};